import React from "react";

export default function CSS_Exercises() {
  return (
    <div className="tutorial-page">
      <h1>CSS Exercises</h1>
      <p>This is the CSS Exercises tutorial page.</p>
    </div>
  );
}
